// Konstanten & gemeinsame Styles für die Cardio-Seite.

export const CARDIO_TYPEN = [
    { value: 'laufen', label: 'Laufen', emoji: '🏃' },
    { value: 'radfahren', label: 'Radfahren', emoji: '🚴' },
    { value: 'schwimmen', label: 'Schwimmen', emoji: '🏊' },
    { value: 'rudern', label: 'Rudern', emoji: '🚣' },
    { value: 'seilspringen', label: 'Seilspringen', emoji: '🪢' },
    { value: 'ellipse', label: 'Ellipse', emoji: '🔄' },
    { value: 'stepper', label: 'Stepper', emoji: '🪜' },
    { value: 'sonstiges', label: 'Sonstiges', emoji: '⚡' },
];

export const INTENSITAETEN = [
    { value: 'leicht', label: 'Leicht', color: '#4ade80' },
    { value: 'moderat', label: 'Moderat', color: '#facc15' },
    { value: 'intensiv', label: 'Intensiv', color: '#fb923c' },
    { value: 'maximal', label: 'Maximal', color: '#f87171' },
];

export const TYPEN_MIT_DISTANZ = ['laufen', 'radfahren', 'schwimmen', 'rudern'];

export const leereForm = {
    datum: new Date().toISOString().split('T')[0],
    cardio_typ: '',
    dauer_minuten: '',
    distanz_km: '',
    durchschnitts_bpm: '',
    max_bpm: '',
    kalorien: '',
    intensitaet: '',
    notizen: '',
};

// Gradient-Button sx (identisch zu Trainingsergebnisse)
export const btnSx = {
    padding: { xs: '10px 16px', sm: '14px 28px' },
    fontSize: { xs: '0.85rem', sm: '1rem' },
    fontWeight: 600,
    borderRadius: '16px',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
    color: '#fff',
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
        background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 24px rgba(30, 64, 175, 0.3)',
    },
    '&:disabled': { opacity: 0.5 },
};
